"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SonicIdentity() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="82119" id="the-skin-n-bonez-story" className="dark bg-black text-white w-full min-h-screen flex items-center justify-center py-12 md:py-24 overflow-hidden" ref={sectionRef}>
      <div className={`w-full max-w-[1600px] mx-auto px-4 md:px-8 transition-all duration-1000 ease-out ${isSectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-10 gap-0 border border-white/10 shadow-2xl shadow-black/50">
          
          {}
          <div className="lg:col-span-6 relative group overflow-hidden aspect-[4/5] lg:aspect-auto lg:min-h-[800px] bg-black">
            {}
            <img src="https://loving-airedale.10web.cloud/wp-content/uploads/2026/03/FOTO2.jpg" alt="Skin N' Bonez Live Performance" className="w-full h-full object-cover object-center filter contrast-125 saturate-50 transition-transform duration-700 group-hover:scale-105" />
            
            {}
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(0,0,0,0.9)_100%)] pointer-events-none" />
            
            {}
            <div className="absolute inset-0 bg-red-600 mix-blend-color opacity-0 group-hover:opacity-40 transition-opacity duration-500 pointer-events-none" />
            <div className="absolute inset-0 bg-red-600/10 mix-blend-multiply opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
            
            {}
            <div className="absolute inset-0 opacity-[0.05] mix-blend-overlay pointer-events-none" style={{
            backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.65%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")'
          }}></div>
          </div>

          {}
          <div className="lg:col-span-4 bg-black p-8 md:p-16 lg:p-20 flex flex-col justify-center relative z-10 border-t lg:border-t-0 lg:border-l border-white/10">
            
            {}
            <div className="absolute top-0 right-0 w-64 h-64 bg-red-600/5 blur-[100px] rounded-full pointer-events-none" />
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-red-600/5 blur-[80px] rounded-full pointer-events-none" />

            <div className="relative z-10">
              <div className="mb-16 md:mb-24">
                <Badge variant="outline" className="border-red-600/50 text-red-600 tracking-[0.2em] uppercase px-4 py-1.5 text-xs md:text-sm bg-red-600/5 backdrop-blur-sm rounded-sm">
                  The Story
                </Badge>
              </div>

              <div ref={textRef} className={`flex flex-col gap-2 md:gap-4 transition-all duration-1000 delay-300 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
                {}
                <h2 className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-serif font-light tracking-tighter text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.5)] uppercase leading-[0.85]">Classic</h2>
                
                {}
                <h2 className="text-6xl md:text-7xl lg:text-8xl xl:text-9xl font-serif font-bold tracking-tighter text-white uppercase leading-[0.85] ml-4 md:ml-8">hard</h2>
                
                {}
                <h2 className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-serif italic tracking-tight text-red-600 uppercase leading-[0.85] ml-8 md:ml-16">heavy</h2>
                <h2 className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-serif font-bold tracking-tighter text-white uppercase leading-[0.85] ml-12 md:ml-24">BLUES ROCK</h2>
              </div>

              <div className="mt-16 md:mt-24 pt-8 border-t border-white/10">
                <p className="text-white/70 text-base md:text-lg leading-relaxed max-w-md font-sans text-sm uppercase tracking-wider">Skin’N Bonez is pure and bring real rock ’n’ roll back to life: loud, raw, and unapologetic. Blending classic grit with a modern edge, the band delivers a live show that’s as dynamic as it is powerful. No gimmicks, no polish! Just ROCK, attitude, and songs that linger like whiskey on a burn. From hard-hitting anthems to smooth, groove-heavy moments, they know how to dial it in and keep the crowd exactly where it belongs: right in the middle of the action.</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}